var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopBar'),_c('div',{staticClass:"wrapper"},[_c('Banner'),_c('MainContent'),_c('hr'),_c('Gallery'),_c('hr'),_c('RTLVideo'),_c('hr'),_c('Contact',{attrs:{"id":"contact-section"}}),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }